import { PartnerType } from "@/app/utils/partners.enum";
import { streamRequest, StreamOptions } from "../http/sseClient";

export type PostTransactionPayload = {
  value: number;
  customerId: string;
  Prazo: number;
  type: PartnerType;
  CodigoTabela?: string;
  clientId: string;
  simulationId?: string;
  refinancingId?: string;
  refinRecurring?: boolean;

  offerId?: string;
  ddd?: number;
  phone?: number;
};

export type PostTransactionResponse = {
  _id: string;
  contract: string;
  value: number;
  status: string;
  seller: unknown;
  customer: unknown;
  createdAt: string;
  updatedAt: string;
};

export async function postTransaction(
  payload: PostTransactionPayload,
  options?: StreamOptions,
) {
  return streamRequest<PostTransactionResponse>({
    method: "POST",
    path: `/crefisa/transaction`,
    body: payload,
    journey: PartnerType.CREFISA,
    ...options,
  });
}
